import { Image } from '@/components/Image';
import s from './index.module.scss';

export const Card = ({ image }) => {
  return (
    <div className={s.slide}>
      <Image
        image={image}
        preset="brandGallery"
        alt={image.name}
        width={290}
        height={180}
      />
    </div>
  );
};
